import { getTimeZone } from '@/utils/dates';
import { format, formatDistanceStrict } from 'date-fns';
import { enUS, es } from 'date-fns/locale';
import { useTranslation } from 'react-i18next';

type DateType = string | number | Date;

const useFormattedDate = (tz?: string ) => {
  const { i18n } = useTranslation();
  const lng = i18n.language === 'es' || i18n.language === 'esAr' ? es : enUS;

  const formattedDate = ({
    date,
    dateFormat = 'dateTime'
  }: {
    date: DateType;
    dateFormat?: 'date' | 'dateTime' | 'time' | 'shortMonth' | 'dateShort' | 'dateNumbers';
  }) => {
    if (
      date === undefined ||
      date === null ||
      (typeof date === 'number' && isNaN(date))
    ) {
      return 'undefined';
    }
    let formatterDateString = 'PP, H:mm';
    if (dateFormat === 'date') formatterDateString = 'PP';
    if (dateFormat === 'dateShort') formatterDateString = 'P';
    if (dateFormat === 'time') formatterDateString = 'H:mm';
    if (dateFormat === 'shortMonth') formatterDateString = 'LLL dd, y';
    if (dateFormat === 'dateNumbers') formatterDateString = 'dd/MM/yyyy';

    return format( tz ? getTimeZone(date, tz) : date, formatterDateString, { locale: lng });
  };

  const formattedDistance = ({
    start,
    end
  }: {
    start: string | number | Date;
    end: string | number | Date;
  }) => {
    if (
      start === undefined ||
      start === null ||
      (typeof start === 'number' && isNaN(start)) ||
      end === undefined ||
      end === null ||
      (typeof end === 'number' && isNaN(end))
    ) {
      return 'undefined';
    }
    return formatDistanceStrict(start, end, { locale: lng });
  };

  return {
    formattedDate,
    formattedDistance
  };
};

export default useFormattedDate;
